import React, { Component } from 'react';
import equal from 'deep-equal';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { UPDATE, GET_LIST, translate, showNotification as onShowNotification } from 'admin-on-rest';
import { Dialog, CircularProgress } from 'material-ui';
import cloneDeep from 'lodash/cloneDeep';
import { connect } from 'react-redux';
import 'react-virtualized/styles.css';
import './styles.css';

import TranslatableField from '../fields/TranslatableField';
import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const DragHandle = SortableHandle(() => <span className="list-handle">::</span>);

const SortableItem = SortableElement(({ rowData, value, editButton, deleteButton, resource }) => (
  <li className="list-item">
    <div className="list-item-value">
      <DragHandle />
      {value}
    </div>
    <div>
      {React.cloneElement(editButton, { record: rowData, resource })}
      {React.cloneElement(deleteButton, { record: rowData, resource })}
    </div>
  </li>
));

const SortableList = SortableContainer(({ items, categories, locale, ...props }) => (
  <div>
    <ul key="sortable-list" className="list-container">
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`} // eslint-disable-line
          index={index}
          rowData={value}
          {...props}
          value={
            <div style={{ position: 'relative' }}>
              <TranslatableField locale={props.locale} data={value.title} />
              {value.promotion &&
                <strong style={{ position: 'absolute', top: '-7px', textTransform: 'uppercase', fontSize: '12px' }}>
                  <small>Promotion</small>
                </strong>
              }
            </div>
          }
        />
      ))}
    </ul>
  </div>
));

class SortableComponent extends Component {
  constructor(props) {
    super(props);
    const items = props.ids.map((id) => props.data[id]);
    this.state = {
      items,
    };
  }

  componentWillMount = () => {
    restClient(GET_LIST, 'position-matrices', {
      sort: {},
      pagination: {},
      filter: { model: 'category' },
    }).then((matrix) => this.setState({ matrix: matrix.data[0].items }));
  }

  componentWillReceiveProps = (nextProps) => {
    if (equal(this.props.ids, nextProps.ids)) return;
    const items = nextProps.ids.map((id) => nextProps.data[id]);
    console.log('items', items);

    this.setState({ items });
  }

  shouldComponentUpdate = (nextProps, nextState) => (!equal(this.props.ids, nextProps.ids) || !equal(this.state.items, nextState.items));

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { items, matrix } = this.state;
    const oldCategories = cloneDeep(items);

    const sourceIndex = matrix.findIndex(
      (code) => code === oldCategories[oldIndex].code
    );
    const targetIndex = matrix.findIndex(
      (code) => code === oldCategories[newIndex].code
    );

    if (oldIndex !== newIndex) {
      const reorderedItems = arrayMove(items, oldIndex, newIndex);
      console.log('hej');

      this.setState({ items: reorderedItems });
    }

    restClient(UPDATE, 'position-matrices', {
      id: 'category',
      data: {
        sourceIndex,
        targetIndex,
        source: oldCategories[oldIndex].code,
        target: oldCategories[newIndex].code,
      },
    }).then((res) =>
      this.setState({ matrix: res.data.items }, () => {
        if (res.data.success) {
          this.props.showNotification(this.props.translate('changedOrder'));
        } else {
          this.props.showNotification(this.props.translate('failedToChangeOrder'), 'warning');
          if (!this.state.loadingCategories) {
            this.getCategories();
          }
        }
      })
    );
  };

  getCategories = () =>
    this.setState(
      { loadingCategories: true },
      () => restClient(GET_LIST, 'categories', {
        sort: {},
        pagination: {},
        filter: {},
      }).then((res) =>
        this.setState({
          loadingCategories: false,
          items: res.data,
        })
      ).catch(() => this.setState({ failedToLoadCategories: true }))
    );

  render() {
    const { resource, ids, multiplier } = this.props;
    const { items, loadingCategories, failedToLoadCategories } = this.state;
    console.log('render', loadingCategories, failedToLoadCategories);

    return (
      ids.length > 0 ?
        <div className="sortable-wrapper">
          <Dialog open={loadingCategories}>
            {failedToLoadCategories ? (
              'Loading failed, reload and try again'
            ) : (
              'Oof, hold on, then try again'
            )}
            &nbsp;
            &nbsp;
            <CircularProgress />
          </Dialog>
          <SortableList
            items={items}
            useDragHandle
            onSortEnd={(props) => this.onSortEnd({ resource, multiplier, ...props })}
            {...this.props}
          />
        </div>
        : null
    );
  }
}

SortableComponent.defaultProps = {
  multiplier: 1,
};

export default connect(
  (state) => state,
  {
    showNotification: onShowNotification,
  }
)(translate(SortableComponent));
